/**
 * Continents and Countries data for location selection
 */

export const CONTINENTS = [
  { value: "europe", label: "Europe" },
  { value: "north-america", label: "North America" },
  { value: "south-america", label: "South America" },
  { value: "asia", label: "Asia" },
  { value: "africa", label: "Africa" },
  { value: "oceania", label: "Oceania" },
];

export const COUNTRIES_BY_CONTINENT = {
  europe: [
    { value: "Germany", label: "Germany" },
    { value: "France", label: "France" },
    { value: "Italy", label: "Italy" },
    { value: "Spain", label: "Spain" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "Netherlands", label: "Netherlands" },
    { value: "Belgium", label: "Belgium" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "Austria", label: "Austria" },
    { value: "Sweden", label: "Sweden" },
    { value: "Norway", label: "Norway" },
    { value: "Denmark", label: "Denmark" },
    { value: "Finland", label: "Finland" },
    { value: "Poland", label: "Poland" },
    { value: "Portugal", label: "Portugal" },
    { value: "Greece", label: "Greece" },
    { value: "Ireland", label: "Ireland" },
    { value: "Czech Republic", label: "Czech Republic" },
    { value: "Romania", label: "Romania" },
    { value: "Hungary", label: "Hungary" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "Russia", label: "Russia" },
    { value: "Other", label: "Other (Europe)" },
  ],
  "north-america": [
    { value: "United States", label: "United States" },
    { value: "Canada", label: "Canada" },
    { value: "Mexico", label: "Mexico" },
    { value: "Other", label: "Other (North America)" },
  ],
  "south-america": [
    { value: "Brazil", label: "Brazil" },
    { value: "Argentina", label: "Argentina" },
    { value: "Chile", label: "Chile" },
    { value: "Colombia", label: "Colombia" },
    { value: "Peru", label: "Peru" },
    { value: "Other", label: "Other (South America)" },
  ],
  asia: [
    { value: "China", label: "China" },
    { value: "Japan", label: "Japan" },
    { value: "India", label: "India" },
    { value: "South Korea", label: "South Korea" },
    { value: "Singapore", label: "Singapore" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Thailand", label: "Thailand" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Philippines", label: "Philippines" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "Turkey", label: "Turkey" },
    { value: "Saudi Arabia", label: "Saudi Arabia" },
    { value: "United Arab Emirates", label: "United Arab Emirates" },
    { value: "Israel", label: "Israel" },
    { value: "Other", label: "Other (Asia)" },
  ],
  africa: [
    { value: "South Africa", label: "South Africa" },
    { value: "Egypt", label: "Egypt" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "Kenya", label: "Kenya" },
    { value: "Morocco", label: "Morocco" },
    { value: "Ghana", label: "Ghana" },
    { value: "Other", label: "Other (Africa)" },
  ],
  oceania: [
    { value: "Australia", label: "Australia" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Other", label: "Other (Oceania)" },
  ],
};

/**
 * Get continent label from value
 */
export const getContinentLabel = (continentValue) => {
  const continent = CONTINENTS.find((c) => c.value === continentValue);
  return continent ? continent.label : "";
};

/**
 * Get countries for a continent
 */
export const getCountriesForContinent = (continentValue) => {
  return COUNTRIES_BY_CONTINENT[continentValue] || [];
};

/**
 * Map continent value to continent name for location object
 */
export const mapContinentValueToName = (continentValue) => {
  const mapping = {
    europe: "Europe",
    "north-america": "North America",
    "south-america": "South America",
    asia: "Asia",
    africa: "Africa",
    oceania: "Oceania",
  };
  return mapping[continentValue] || "";
};

